import moment from 'moment';

// Calculate today's date
const today = new Date();

// Calculate the maximum date (12 years ago)
const maxDate = moment(new Date(today.getFullYear() - 12, today.getMonth(), today.getDate())).format('YYYY-MM-DD');

// Calculate the minimum date (80 years ago)
const minDate = moment(new Date(today.getFullYear() - 80, today.getMonth(), today.getDate())).format('YYYY-MM-DD');

const todayDate = moment(new Date(today.getFullYear(), today.getMonth(), today.getDate())).format('YYYY-MM-DD');

const afterTodayDate = moment(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1)).format('YYYY-MM-DD');


export { maxDate, minDate, todayDate, afterTodayDate };